/**
 * @flow
 * @relayHash db85c6c2d3f2a31a4cd3eb1c7f5dffdf
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ProfileStatsContainer_user$ref = any;
export type ProfileStatsViewQueryVariables = {|
  userId: string
|};
export type ProfileStatsViewQueryResponse = {|
  +user: ?{|
    +$fragmentRefs: ProfileStatsContainer_user$ref
  |}
|};
export type ProfileStatsViewQuery = {|
  variables: ProfileStatsViewQueryVariables,
  response: ProfileStatsViewQueryResponse,
|};
*/


/*
query ProfileStatsViewQuery(
  $userId: String!
) {
  user(userId: $userId) {
    ...ProfileStatsContainer_user
    id
  }
}

fragment ProfileStatsContainer_user on User {
  id
  username
  heartsUntilNextLevel
  joined
  level
  maxTabsDay {
    date
    numTabs
  }
  numUsersRecruited
  tabs
  vcDonatedAllTime
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ProfileStatsViewQuery",
  "id": null,
  "text": "query ProfileStatsViewQuery(\n  $userId: String!\n) {\n  user(userId: $userId) {\n    ...ProfileStatsContainer_user\n    id\n  }\n}\n\nfragment ProfileStatsContainer_user on User {\n  id\n  username\n  heartsUntilNextLevel\n  joined\n  level\n  maxTabsDay {\n    date\n    numTabs\n  }\n  numUsersRecruited\n  tabs\n  vcDonatedAllTime\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ProfileStatsViewQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ProfileStatsContainer_user",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ProfileStatsViewQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "username",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "heartsUntilNextLevel",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "joined",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "level",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "maxTabsDay",
            "storageKey": null,
            "args": null,
            "concreteType": "MaxTabsDay",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "date",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "numTabs",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "numUsersRecruited",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "tabs",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "vcDonatedAllTime",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '27c52e53129ab27d635f00d7281c2b21';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Settings/Profile/__generated__/ProfileStatsViewQuery.graphql.js